import { useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'

import { TRANSLATION_KEYS } from '../../../../../translations'

import styles from './RejectDialogContent.module.scss'

export type RejectDialogProps = {
  onReject: (comment: string) => void
  onCancel: () => void
  isPending: boolean
  isError: boolean
}

export const RejectDialogContent = ({
  onReject,
  onCancel,
  isPending,
  isError,
}: RejectDialogProps) => {
  const [comment, setComment] = useState('')
  return (
    <div className={styles.dialog}>
      <p>
        <Translation text={TRANSLATION_KEYS.rejectPrompt} span />
      </p>
      <Input
        value={comment}
        onChange={setComment}
        label={<Translation text={TRANSLATION_KEYS.reason} />}
      />

      {isError && (
        <p className={styles.error}>
          <Translation text={TRANSLATION_KEYS.rejectError} span />
        </p>
      )}
      <div className={styles.actions}>
        <Button variant="outlined" disabled={isPending} onClick={onCancel}>
          <Translation text={TRANSLATION_KEYS.cancel} span />
        </Button>
        <Button
          color="danger"
          loading={isPending}
          disabled={isPending || !comment.trim()}
          onClick={() => onReject(comment)}
        >
          <Translation text={TRANSLATION_KEYS.reject} span />
        </Button>
      </div>
    </div>
  )
}
